module.exports = new __parcel__URL__("bossfight_defeat_title.f6b4ef43.png").toString();